var render = function render(_c,_vm){return _c('a',_vm._b({class:[_vm.data.staticClass, _vm.data.class],attrs:{"href":_vm.props.path,"target":_vm.props.target}},'a',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }